import { ContentWrapper } from "@/components/layout/content";
import { GlitchText } from "@/components/ui/GlitchText";

export function PortfolioSection() {
  const projects = [
    {
      id: "repo-01",
      title: "[Web-App] E-Commerce Redesign",
      description:
        "Ein komplettes Redesign und Architektur-Upgrade für ein modernes Einkaufserlebnis. Nahtlose Performance trifft auf Conversion-optimiertes Design.",
      tags: ["React", "Node.js", "TailwindCSS"],
    },
    {
      id: "repo-02",
      title: "[Brand] Corporate Identity & Dev",
      description:
        "Von der Logogestaltung über die Fotografie bis hin zur fertigen Corporate Website. Eine ganzheitliche Markenentwicklung aus einer Hand.",
      tags: ["Photography", "Figma", "Angular", ".NET"],
    },
  ];

  return (
    <section className="py-24 bg-transparent" id="portfolio">
      <ContentWrapper>
        <div className="mb-16">
          <h2 className="text-3xl md:text-4xl font-mono font-bold text-gray-50">
            <GlitchText text="Letzte Commits:" glitchClassName="text-emerald-400" />
            <br className="md:hidden" />
            <GlitchText
              text="Erfolgreich geschlossene Lücken."
              glitchClassName="text-emerald-400"
            />
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-12">
          {projects.map((p) => (
            <div
              key={p.id}
              className="bg-gray-950 border border-gray-800 group hover:border-emerald-500/50 transition-all duration-500 rounded-sm overflow-hidden flex flex-col md:flex-row shadow-xl"
            >
              {/* Brilliant Image Area */}
              <div className="h-64 md:h-auto md:w-3/5 bg-gray-900 relative flex items-center justify-center overflow-hidden border-b md:border-b-0 md:border-r border-gray-800">
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-gray-800/50 to-transparent"></div>
                <span className="font-mono text-gray-600 text-sm z-10">
                  [Premium_Mockup_{p.id}.raw]
                </span>
                {/* Simulated image overlay effect on hover */}
                <div className="absolute inset-0 bg-emerald-500/0 group-hover:bg-emerald-500/5 transition-colors duration-500 mix-blend-overlay"></div>
              </div>

              <div className="p-8 md:w-2/5 flex flex-col">
                <div className="flex justify-between items-start mb-6 font-mono text-xs text-gray-500">
                  <span>status: deployed</span>
                  <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></div>
                </div>

                <h3 className="text-2xl font-mono font-bold text-gray-50 mb-4 group-hover:text-emerald-400 transition-colors">
                  {p.title}
                </h3>

                <p className="text-gray-400 font-sans text-base leading-relaxed mb-8 flex-1">
                  {p.description}
                </p>

                <div className="flex flex-wrap gap-2 mt-auto pt-6 border-t border-gray-900">
                  {p.tags.map((tag) => (
                    <span key={tag} className="text-xs font-mono text-gray-500">
                      <span className="text-emerald-500 mr-1">&gt;</span>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </ContentWrapper>
    </section>
  );
}
